import * as types from '../constants/ActionTypes';
import { isNaaTypeExists } from '../../lib/globalHelper';

const initialState = {
  isLoading: false,
  error: false,
  articles: [],
  isNaaExists: false,
  isNetNewAccount: false,
  omniChannelIntentArticles: {},
  isOmniChannelPromptEnabled: false,
  hideOmniChannelPrompt: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_POPULAR_LIST:
      return {
        ...state,
        isLoading: true,
        error: false,
        articles: [],
        isNaaExists: false,
        isNetNewAccount: false,
        omniChannelIntentArticles: {},
        isOmniChannelPromptEnabled: false,
        hideOmniChannelPrompt: true,
      };
    case types.RECEIVE_POPULAR_LIST:
      return {
        ...state,
        isLoading: false,
        error: false,
        articles: action.payload.articles,
        isNaaExists: isNaaTypeExists(action.payload.articles),
        isNetNewAccount: action.payload.params.isNetNewAccount,
        omniChannelIntentArticles: action.payload.params.ocpData.intents,
        isOmniChannelPromptEnabled: action.payload.params.ocpData.isOmniChannelPromptEnabled,
        hideOmniChannelPrompt: false,
      };
    case types.RECEIVE_POPULAR_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        articles: [],
        isNaaExists: false,
        isNetNewAccount: false,
        omniChannelIntentArticles: {},
        isOmniChannelPromptEnabled: false,
        hideOmniChannelPrompt: true,
      };

    case types.RECEIVED_POPULAR_LIST_NAA:
      return {
        ...state,
        isLoading: false,
        error: false,
        articles: [],
        isNaaExists: isNaaTypeExists(action.payload.articles),
        isNetNewAccount: false,
        omniChannelIntentArticles: {},
        isOmniChannelPromptEnabled: false,
        hideOmniChannelPrompt: true,
      };

    case types.RESET_OMNI_CHANNEL_PROMPT_INFO:
      return {
        ...state,
        hideOmniChannelPrompt: true,
      };
    default:
      return state;
  }
}
